// extracted by mini-css-extract-plugin
export default {"root":"Categories_root__1UQ1I","image":"Categories_image__2RiiQ"};